'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_WebSockets$Frame(data) {
  this.Kn = null;
  this.Kn = data;
}
export { $c_Lpresto_WebSockets$Frame as $c_Lpresto_WebSockets$Frame };
$p = $c_Lpresto_WebSockets$Frame.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_WebSockets$Frame;
/** @constructor */
function $h_Lpresto_WebSockets$Frame() {
}
export { $h_Lpresto_WebSockets$Frame as $h_Lpresto_WebSockets$Frame };
$h_Lpresto_WebSockets$Frame.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_WebSockets$Frame) && (this.Kn === x$0.Kn)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "Frame";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Kn;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_WebSockets$Frame(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j4)));
}
export { $isArrayOf_Lpresto_WebSockets$Frame as $isArrayOf_Lpresto_WebSockets$Frame };
var $d_Lpresto_WebSockets$Frame = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_WebSockets$Frame, "presto.WebSockets$Frame", ({
  j4: 1,
  d8: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_WebSockets$Frame as $d_Lpresto_WebSockets$Frame };
//# sourceMappingURL=presto.-Web-Sockets$-Frame.js.map
